import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton } from '@material-ui/core';
import VisibilityOffOutlinedIcon from '@material-ui/icons/VisibilityOffOutlined';
import VisibilityOutlinedIcon from '@material-ui/icons/VisibilityOutlined';

const useStyles = makeStyles(() => ({
  root: {
    zIndex: 50,
    marginLeft: 5,

    '&.MuiIconButton-root': {
      color: '#8e8e8e',
    },
  },
}));

const CellToggleHide = ({
  show = false,
  onToggle = () => {},
  className = '',
}) => {
  const classes = useStyles();

  const onClick = (e) => {
    e.stopPropagation();
    onToggle(e);
  };

  return (
    <IconButton
      className={`${classes.root} ${className}`}
      onClick={onClick}
      size="small"
      color="primary"
    >
      {show ? (
        <VisibilityOffOutlinedIcon fontSize="small" />
      ) : (
        <VisibilityOutlinedIcon fontSize="small" />
      )}
    </IconButton>
  );
};

export default CellToggleHide;
